import React, { useEffect, useState } from 'react';
import type { FC } from 'react';
import cn from 'classnames';

import { ModalContext } from '../context';

import type { TModalV2Desktop, TOnCloseHandler } from './models';

const emptyFunction = () => {};

export const ModalV2: FC<TModalV2Desktop> = ({
    Backdrop,
    Stack,
    disableAutoFocus,
    disableFocusLock,
    disableRestoreFocus,
    Modal,
    className,
    classNames,
    children,
    dataTestId,
    fixedPosition,
    onClose = emptyFunction,
    prohibitClosing = [],
    size = 's',
    styles,
    transitionProps,
    keepMounted,
    usePortal,
    isOpen = true,
    zIndex = 100,
}) => {
    const [open, setIsOpen] = useState(isOpen);

    useEffect(() => {
        setIsOpen(isOpen);
    }, [isOpen]);

    const handleClose: TOnCloseHandler = (event, reason) => {
        if (prohibitClosing.length && reason && prohibitClosing.includes(reason)) return;
        setIsOpen(false);
        onClose(event, reason);
    };

    return (
        <div className={className}>
            <ModalContext.Provider value={{ size, handleClose }}>
                <Stack value={zIndex}>
                    {zIndexStacked => (
                        <Modal
                            Backdrop={Backdrop}
                            className={cn(styles?.modalV2, classNames?.modal)}
                            contentClassName={cn(classNames?.content)}
                            dataTestId={dataTestId}
                            disableAutoFocus={disableAutoFocus}
                            disableFocusLock={disableFocusLock}
                            disableRestoreFocus={disableRestoreFocus}
                            fixedPosition={fixedPosition}
                            keepMounted={keepMounted}
                            onClose={handleClose}
                            open={open}
                            size={size}
                            transitionProps={transitionProps}
                            usePortal={usePortal}
                            wrapperClassName={cn(classNames?.wrapper)}
                            zIndex={zIndexStacked}
                        >
                            {children}
                        </Modal>
                    )}
                </Stack>
            </ModalContext.Provider>
        </div>
    );
};
